import React, { Component } from "react";

class TabsState extends Component {
  constructor(props) {
    super(props);

    this.state = {
        currentTab: 0
    }
  }

  render() {
    const { routes } = this.props;
    const { currentTab } = this.state;

    return (
      <div id="nav-bar">
        <ul className="nav-bar">
          {routes.map((route, idx) =>
              <div
                  key={route.path}
                  className={`nav-link ${idx === currentTab ? 'active' : ''}`}
                  onClick={() => this.handleTabClick(idx)}
              >
                  {route.title}
              </div>
          )}
        </ul>
        <div className='route-section'>{routes[currentTab].component()}</div>
      </div>
    );
  }

  handleTabClick(tabIndex) {
      this.setState({
          currentTab: tabIndex
      })
  }
}
export default TabsState;